/// <amd-module name="Wit/BacklogsHub/BacklogSettings/Components/BacklogSettingsPanel.Props" />
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { IBacklogSettingsData } from "Wit/Common/BacklogContentService/BacklogContentDataProviderTypes";
import { ITeamSettingsPanelProps } from "Wit/Common/TeamSettingsPanel/Components/TeamSettingsPanel.Props";

export interface IBacklogSettingsPanelProps extends Pick<ITeamSettingsPanelProps, "onDismiss" | "onSave" | "teamId"> {
    backlogSettingsData: IReadonlyObservableValue<IBacklogSettingsData | undefined>;
}
